import { IS_WEB } from 'constants/platform'
import React, { useCallback } from 'react'

import { Box } from 'widgets/Box'
import { FlatList } from 'widgets/FlatList'
import { Title } from 'widgets/Title'

import { TagGroup } from 'types/workoutTag'

import { Tag } from './Tag'

type HorizontalTagsLayoutProps = {
  data: TagGroup
  hideTitle?: boolean
  wrapItemTitle?: boolean
  selectedItems?: string[]
  onSelect?: (index: number) => void
}

export const HorizontalTagsLayout = ({
  data,
  selectedItems,
  wrapItemTitle = false,
  hideTitle = false,
  onSelect,
}: HorizontalTagsLayoutProps) => {
  const getTitle = useCallback(
    (index: number) => {
      const item = data.tags[index]
      let itemTitle = `${item}${
        !Number.isNaN(parseInt(item, 10)) && parseInt(item, 10) >= 60 ? '+' : ''
      }`

      if (wrapItemTitle) {
        itemTitle = itemTitle.split(' ')[0] ?? ''
      }

      return itemTitle
    },
    [data.tags, wrapItemTitle],
  )

  return (
    <Box>
      {!hideTitle && data.name && (
        <Box margin={{ top: 'xxs', bottom: 'smd' }}>
          <Title size='xs' bold>
            {data.name}
          </Title>
        </Box>
      )}

      <Box flexDirection={IS_WEB ? 'column' : 'row'} margin={{ vertical: 'xs' }}>
        <FlatList<string>
          horizontal
          bounces={false}
          data={data.tags}
          renderItem={({ item, index }) => (
            <Tag
              type={data.style}
              title={getTitle(index)}
              subtitle={!wrapItemTitle ? 'min' : undefined}
              selected={
                (selectedItems !== undefined && selectedItems.includes(item)) || onSelect == null
              }
              onPress={onSelect ? () => onSelect(index) : undefined}
            />
          )}
        />
      </Box>
    </Box>
  )
}
